const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFizy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1200px",
    height: "1145px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.969
    },
    fill: "#facf00",
    d: "M 385.5,12.5 C 458.402,9.6429 526.735,25.8096 590.5,61C 736.005,142.92 881.672,224.587 1027.5,306C 1141.23,368.904 1196.39,465.737 1193,596.5C 1182.36,706.348 1129.2,788.181 1033.5,842C 884.51,924.827 735.843,1008.16 587.5,1092C 486.212,1145.38 381.546,1153.05 273.5,1115C 146.932,1063.76 65.4315,972.259 29,840.5C 22.6167,814.867 18.6167,788.867 17,762.5C 16.3333,637.833 16.3333,513.167 17,388.5C 26.5208,261.252 82.0208,159.752 183.5,84C 244.212,41.5953 311.545,17.762 385.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 385.5,25.5 C 447.041,23.4765 505.708,35.3098 561.5,61C 727.267,152.465 892.267,245.132 1056.5,339C 1142.47,402.114 1183.64,487.281 1180,594.5C 1169.34,702.067 1116.84,781.567 1022.5,833C 872.911,916.266 723.578,999.933 574.5,1084C 467.518,1136.83 359.518,1139.16 250.5,1091C 130.872,1031.32 59.0389,935.491 35,803.5C 32.6747,788.239 31.008,772.905 30,757.5C 29.0312,630.489 29.3645,503.489 31,376.5C 44.1757,254.917 100.342,159.084 199.5,89C 256.008,51.5535 318.008,30.3868 385.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 249.5,413.5 C 248.505,425.322 248.172,437.322 248.5,449.5C 273.833,449.5 299.167,449.5 324.5,449.5C 346.213,453.038 356.047,465.704 354,487.5C 349.4,501.934 339.566,509.934 324.5,511.5C 299.167,511.5 273.833,511.5 248.5,511.5C 248.5,564.833 248.5,618.167 248.5,671.5C 246.81,687.363 238.143,697.197 222.5,701C 202.42,703.884 188.587,696.051 181,677.5C 180.333,586.833 180.333,496.167 181,405.5C 191.434,363.066 217.934,336.566 260.5,326C 272.733,323.975 285.066,323.142 297.5,323.5C 307.556,323.385 317.556,323.885 327.5,325C 349.359,334.222 355.526,349.722 346,371.5C 339.836,379.653 331.67,384.486 321.5,386C 306.5,386.333 291.5,386.667 276.5,387C 262.302,390.699 253.302,399.532 249.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbd000",
    d: "M 411.5,323.5 C 435.577,322.11 451.41,332.777 459,355.5C 461.263,379.888 450.763,395.721 427.5,403C 403.46,405.937 387.293,396.104 379,373.5C 375.988,347.703 386.821,331.036 411.5,323.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f4f4f",
    d: "M 249.5,413.5 C 249.5,425.167 249.5,436.833 249.5,448.5C 274.672,448.169 299.672,448.502 324.5,449.5C 299.167,449.5 273.833,449.5 248.5,449.5C 248.172,437.322 248.505,425.322 249.5,413.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 405.5,449.5 C 418.626,448.319 430.126,451.985 440,460.5C 442.852,464.204 445.185,468.204 447,472.5C 447.667,541.167 447.667,609.833 447,678.5C 440.764,693.88 429.264,701.547 412.5,701.5C 399.604,701.303 389.438,695.969 382,685.5C 380.438,683.043 379.438,680.376 379,677.5C 378.333,609.167 378.333,540.833 379,472.5C 382.015,463.484 387.849,456.984 396.5,453C 399.718,452.1 402.718,450.933 405.5,449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 705.5,449.5 C 720.47,448.402 731.97,454.069 740,466.5C 761,517.167 782,567.833 803,618.5C 824.057,566.719 845.39,515.052 867,463.5C 879.414,448.234 894.247,445.4 911.5,455C 924.155,465.304 927.655,478.137 922,493.5C 879.333,598.167 836.667,702.833 794,807.5C 786.494,823.338 773.994,829.838 756.5,827C 737.324,819.483 730.157,805.649 735,785.5C 746.509,757.633 758.009,729.799 769.5,702C 739.862,630.557 710.362,559.057 681,487.5C 679.311,468.375 687.478,455.708 705.5,449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 583.5,525.5 C 584.043,525.44 584.376,525.107 584.5,524.5C 560.509,523.5 536.509,523.167 512.5,523.5C 495.397,520.327 486.397,509.994 485.5,492.5C 486.488,477.34 494.155,467.173 508.5,462C 556.5,461.333 604.5,461.333 652.5,462C 672.581,469.662 679.748,483.829 674,504.5C 641.29,552.753 608.457,600.92 575.5,649C 600.833,649.333 626.167,649.667 651.5,650C 672.5,654.332 682,667.165 680,688.5C 676.069,702.548 666.902,710.715 652.5,713C 604.833,713.667 557.167,713.667 509.5,713C 487.417,706.333 479.25,691.833 485,669.5C 517.596,621.298 550.429,573.298 583.5,525.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#464646",
    d: "M 324.5,511.5 C 299.672,512.498 274.672,512.831 249.5,512.5C 249.832,565.669 249.499,618.669 248.5,671.5C 248.5,618.167 248.5,564.833 248.5,511.5C 273.833,511.5 299.167,511.5 324.5,511.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cacaca",
    d: "M 512.5,523.5 C 536.509,523.167 560.509,523.5 584.5,524.5C 584.376,525.107 584.043,525.44 583.5,525.5C 559.833,524.833 536.167,524.167 512.5,523.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFizy);
export default __webpack_public_path__ + "static/media/fizy.982d830e7e0bc42c02cb83c3da8f69bc.svg";
export { ForwardRef as ReactComponent };